const DEFAULT_NON_GAM_SALES_PRODUCTS = ['CTM', 'JX', 'JCS', 'JSX'];
const DEFAULT_TWO_LINE_ITEM_SALES_PRODUCTS = ['JCI', 'JNU'];
const THREE_LINE_ITEM_SALES_PRODUCTS = ['JNUI'];
const TWO_LINE_ITEM_SALES_PRODUCT_NAMES = [
  'JAG Contextual + Intrasite',
  'JAG New + Used',
  'JAG NU + Intrasite',
  'MTG Contextual + Intrasite'
];

const salesProductCode = salesProduct => {
  if (!salesProduct) return '';
  if (typeof salesProduct === 'string') return salesProduct;
  return salesProduct.code || '';
};

const salesProductName = salesProduct => {
  if (!salesProduct || typeof salesProduct === 'string') return salesProduct || '';
  return salesProduct.name || '';
};

// Return the number of GAM line items a placement's sales product creates.
// Products that do not push to GAM intentionally return zero.
export const lineItemCountForSalesProduct = (salesProduct, constants = {}) => {
  const code = salesProductCode(salesProduct);
  const name = salesProductName(salesProduct);
  const nonGamProducts = constants.spNotAdManager || DEFAULT_NON_GAM_SALES_PRODUCTS;

  if (nonGamProducts.includes(code)) return 0;
  if (THREE_LINE_ITEM_SALES_PRODUCTS.includes(code) || name === 'JAG New + Used + Intrasite') return 3;
  if (DEFAULT_TWO_LINE_ITEM_SALES_PRODUCTS.includes(code) || TWO_LINE_ITEM_SALES_PRODUCT_NAMES.includes(name)) {
    return 2;
  }
  return salesProduct ? 1 : 0;
};

// We can only count line items if there is an order and some placements
export const countLineItems = (order) => {
  const PROG_LIMIT = 150;
  const DIRECT_LIMIT = 450;
  const PRE_CONTRACT_LIMIT = 450;
  if (!order) {
    return { itemCount: 0, itemRemainder: DIRECT_LIMIT, itemLimit: DIRECT_LIMIT };
  }
  let limit = DIRECT_LIMIT;
  if (order.IoStatusId < 4) {
    limit = PRE_CONTRACT_LIMIT
  } else {
    limit = order.orderType === 'Programmatic' ? PROG_LIMIT : DIRECT_LIMIT;
  }
  if (!order.Placements) {
    return { itemCount: 0, itemRemainder: limit, itemLimit: limit };
  }
  let count = 0;
  order.Placements.forEach(p => {
    // Existing LineItems are the source of truth for the order. They represent
    // the GAM lines already created; non-GAM placements have no such lines.
    if (Array.isArray(p.LineItems)) {
      count += p.LineItems.length;
    } else {
      count += lineItemCountForSalesProduct(p.SalesProduct || p.salesProduct);
    }
  });
  return { itemCount: count, itemRemainder: limit - count, itemLimit: limit };
};
